import { useCallback, useLayoutEffect, useState } from "react";
import { Outlet } from "react-router";
import _ from "lodash";

import theme from "theme";
import { colors } from "theme/palette";
import {
  getItem,
  getToken,
  IDLE_TIME,
  removeToken,
  setItem,
} from "utils/storage";

import Backdrop from "components/Backdrop";
import Button from "components/Button";
import Paper from "components/Paper";
import Stack from "components/Stack";
import Text from "components/Text";

import { logout } from "entities/Auth/sdk";

import { IDLE_TIME_INTERVAL, MAX_IDLE_TIME } from "./constants";

let intervalVar: any = undefined;

const AutomaticLogout = () => {
  const [isTimeout, setIsTimeout] = useState(false);

  const updateIdleTime = _.throttle(() => {
    setItem({
      key: IDLE_TIME,
      value: (Date.now() + MAX_IDLE_TIME * 60000).toString(),
      shouldDispatchEvent: false,
    });
  }, 500);

  useLayoutEffect(() => {
    window.addEventListener("mousemove", updateIdleTime);
    window.addEventListener("scroll", updateIdleTime);
    window.addEventListener("click", updateIdleTime);
    window.addEventListener("keydown", updateIdleTime);

    return () => {
      window.removeEventListener("mousemove", updateIdleTime);
      window.removeEventListener("scroll", updateIdleTime);
      window.removeEventListener("click", updateIdleTime);
      window.removeEventListener("keydown", updateIdleTime);
    };
  }, [updateIdleTime]);

  useLayoutEffect(() => {
    updateIdleTime();

    if (!intervalVar) {
      intervalVar = setInterval(() => {
        const idleTime = parseInt(
          getItem(IDLE_TIME) || (Date.now() + MAX_IDLE_TIME * 60000).toString()
        );

        if (idleTime < Date.now()) {
          intervalVar = clearTimeout(intervalVar);
          setIsTimeout(true);
          removeToken();
        }
      }, IDLE_TIME_INTERVAL);
    }

    return () => (intervalVar = clearTimeout(intervalVar));
  }, [updateIdleTime]);

  const storageUpdateListener = useCallback(() => {
    const token = getToken();

    setIsTimeout(_.isNil(token));
  }, []);

  useLayoutEffect(() => {
    window.addEventListener("storage update", storageUpdateListener);

    return () => {
      window.removeEventListener("storage update", storageUpdateListener);
    };
  }, [storageUpdateListener]);

  return (
    <>
      <Backdrop
        open={isTimeout}
        sx={{
          alignItems: "flex-start",
          zIndex: 1500,
          backgroundColor: colors.white,
          opacity: 0.9,
        }}
      >
        <Paper
          sx={{ padding: theme.spacing(4), marginTop: theme.spacing(15) }}
          elevation={4}
        >
          <Stack alignItems="center" spacing={1}>
            <Text variant="h3">
              Your session has expired, please log in again to continue
            </Text>
            <Button size="large" onClick={logout}>
              Log in
            </Button>
          </Stack>
        </Paper>
      </Backdrop>
      <Outlet />
    </>
  );
};

export default AutomaticLogout;
